import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface Props {
  formMode: FormMode;
}

export const HDDTTab = ({ formMode }: Props) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Sử dụng hđ điện tử</Label>
          <div className='w-[250px]'>
            <FormField
              name='use_einvoice'
              type='select'
              disabled={isViewMode}
              options={[
                { label: '1. Có', value: '1' },
                { label: '0. Không', value: '0' }
              ]}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Thư nhận HĐĐT</Label>
          <div className='w-[250px]'>
            <FormField name='einvoice_email' type='text' disabled={isViewMode} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Người đại diện</Label>
          <div className='w-full'>
            <FormField name='representative' type='text' disabled={isViewMode} />
          </div>
        </div>
      </div>
    </div>
  );
};
